import { sanitizeStr } from '../../../../utils/sanitizeStr';
import { fieldNames, apiKeys } from './constants';

export const checkDateTime = (_rule, value, callback) => {
  if (!value || (!value.date && !value.time)) {
    return callback('Укажите дату и время выполнения');
  }

  if (!value.date) {
    return callback('Укажите дату выполнения');
  }

  if (!value.time) {
    return callback('Укажите время выполнения');
  }

  callback();
};

export const transformValues = (values) => {
  const { date, time } = values[fieldNames.executeDateTime];

  const dateTime = date.clone().set({
    hour: time.hour(),
    minute: time.minute(),
    second: 0,
  });

  return {
    [apiKeys.executeDate]: dateTime.utc().format(),
    [apiKeys.note]: sanitizeStr(values[fieldNames.note]),
  };
};
